import { Observable } from 'rxjs';

/** Breakpoints currently used for responsivity */
export abstract class SimplifiedConnectedBreakpointService {
  abstract xl$: Observable<boolean>;
  abstract md$: Observable<boolean>;
  /** Will always emit true */
  abstract change$: Observable<boolean>;

  // shouldn't be used in templates!
  abstract get md(): boolean;

  abstract get xl(): boolean;
}
